<span privaAppVersionAttributes></span>
@if (hasLoadedLanguage) {
    <div
        id="root"
        [class.has-notification-bar]="hasNotificationBar"
        [class.has-primary-nav]="hasPrimaryNav"
        [priva-toggle-class]="{ contentActions: 'has-content-overlay' }"
        [appshell-deactivate-area]="[AreaTypes.SidebarLocalLeft]"
        [priva-toggle-deactivate]="['contentActions', 'showPrimaryNavItems', 'actionmenu']"
    >
        <!-- AREA | COMPONENT: Notification messages -->
        <priva-notifications />

        <!-- App Shell main component -->
        <router-outlet />
    </div>
}
